// HEADER VARIABLES
var header = document.getElementById('site-header');
var menuToggle = document.querySelector(".site-header__menu-toggle");
var menu = document.querySelector("#site-navigation");
var menuOpen = false;





// MENU EXPAND TOGGLE
if (menuToggle !== null && menu !== null) {
	menuToggle.addEventListener("click", menuExpand);

	function menuExpand() {
		let searchPanel = document.querySelector(".site-header__search-panel");
		let searchToggle = document.querySelector(".site-header__search");

		if (this.classList.contains("--expand")) {
			this.classList.remove("--expand");
		} else {
			this.classList.add("--expand");
			searchPanel.classList.remove("active");
			searchToggle.classList.remove("active");
		}

		if (menu.classList.contains("--expand")) {
			menu.classList.remove("--expand");
		} else {
			menu.classList.add("--expand");
		}
	}
}

document.addEventListener('click', (e) => {
	if (!e.target.closest('#site-header')) {
		menu.classList.remove('--expand');
		menuToggle.classList.remove('--expand');
	}
});

// CLOSE MENU WHEN CLICKING OUTSIDE OF MENU ON DESKTOP
// window.addEventListener('click', function(e){
// 	if (window.innerWidth > 991) {
// 		if (document.getElementById('site-header').contains(e.target)){
// 			return;
// 		} else {
// 			menuToggle.classList.remove("--expand");
// 			menu.classList.remove("--expand");
// 		}
// 	}
// });

// ADD PADDING TO ALIGN MENUS ON DESKTOP BASED ON PRIMARY MENU
var mainMenu = document.querySelector(".menu-header-container");
var subMenus = document.querySelectorAll(".sub-menu-container");

function subMenuPadding() {
	if (window.innerWidth > 991) {
		var mainMenuTop = mainMenu.offsetTop;

		for (var i = 0; i < subMenus.length; ++i) {
			subMenus[i].style.paddingTop = mainMenuTop + "px";
		}
	} else {
		for (var i = 0; i < subMenus.length; ++i) {
			subMenus[i].style.paddingTop = "10px";
		}
	}
}

if (mainMenu !== null) {
	subMenuPadding();
	window.addEventListener("resize", subMenuPadding);
}

// HIDE/SHOW DROPDOWN LINKS BASED ON MOUSEOVER
function revealMenuDesktop(e) {
	if (window.innerWidth > 991) {
		e.stopPropagation();

		var dropdownLinks = document.querySelectorAll(".menu-item-has-children");
		for (var i = 0; i < dropdownLinks.length; ++i) {
			dropdownLinks[i].style.pointerEvents = "none";
			e.target.style.pointerEvents = "auto";
		}

		setTimeout(function(){

			if (!e.target.classList.contains('sub-menu-container__back')) {

				for (var i = 0; i < dropdownLinks.length; ++i) {
					dropdownLinks[i].style.pointerEvents = "none";
					dropdownLinks[i].classList.remove("js-hover");
				}

				var parentDropdown = e.target.closest(".menu-item-has-children");
				parentDropdown.style.zIndex = "9999999"
				// console.log(parentDropdown);
				parentDropdown.classList.add("js-hover");
			}
		}, 1000);

	}
}

function closeMenu() {
	setTimeout(function(){
		this.classList.remove("js-hover");
		this.style.zIndex = "1"
	}, 1000);
}

function revealMenuMobile(e) {
	if (window.innerWidth < 992) {
		e.stopPropagation();
		if (!e.target.classList.contains('sub-menu-container__back')) {
			var parentDropdown = e.target.closest(".menu-item-has-children");
			// console.log(parentDropdown);
			parentDropdown.classList.add("js-hover");
		}
	}
}

// if (window.innerWidth > 991) {
// 	header.addEventListener('mouseleave', function(e){;
// 		menuToggle.classList.remove("--expand");
// 		menu.classList.remove("--expand");
// 	});
// }

var dropdownLinks = document.querySelectorAll(".menu-item-has-children");

function resizeLinks() {
	for (var i = 0; i < dropdownLinks.length; ++i) {
		var dropdownLink = dropdownLinks[i];

		if (window.innerWidth < 992) {
			dropdownLink.addEventListener("click", function(e) {revealMenuMobile(e)});
		} else {
			// dropdownLink.addEventListener("mouseover", function(e) {revealMenuDesktop(e)});
			// dropdownLink.addEventListener("mouseleave", closeMenu);
		}
	}
}


function activeList(){
	jQuery(this).addClass("js-hover");
}

function deactiveList() {
	jQuery(this).removeClass("js-hover");
}


if (window.innerWidth > 992) {
	jQuery("#site-navigation").hoverIntent({
		over: activeList,
		out: deactiveList,
		selector: '.menu-item',
		timeout: 300,
	});
}

resizeLinks();
window.addEventListener("resize", resizeLinks);

// BACK LINKS FOR MENU ON MOBILE
var backLinks = document.querySelectorAll(".sub-menu-container__back");

function findAndCloseMenu() {
	if (window.innerWidth < 992) {
		var parent = this.closest(".js-hover");
		parent.classList.remove("js-hover");
	}
}

for (var i = 0; i < backLinks.length; ++i) {
	var backLink = backLinks[i];
	backLink.addEventListener("click", findAndCloseMenu);
}

// back to top button
/* BEGIN: AI Suggested */
document.addEventListener("DOMContentLoaded", function() {
	var body = document.body,
		html = document.documentElement;

	var height = Math.max( body.scrollHeight, body.offsetHeight,
		html.clientHeight, html.scrollHeight, html.offsetHeight );

	var backToTop = document.querySelector("[data-back-to-top]");

	function showBackToTop() {
		if (window.scrollY > height / 2) {
			backToTop.classList.add("is-visible");
		} else {
			backToTop.classList.remove("is-visible");
		}
	}

	if (backToTop !== null) {
		window.addEventListener("scroll", showBackToTop);

		backToTop.addEventListener("click", function() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		});
	}
});
/* END: AI Suggested */